import { Skeleton } from "@mui/material";
import { AccordionBody, DescriptionTypography } from "./PathCourseAccordion.styles";
import { ActivityDotNavigation, ActivityNavigationItem } from "../../components/CourseActivityCard";
import { SkeletonCard } from "../../components/ModalEditionChange/SkeletonCard";
import type {  ReferencedCourse } from "../../types";


const ActivityAccordion = ({
  course,
  isLoading,
  activities,
  description,
  isStandaloneComponent=false,
  initialActiveLoId,
  deepLinkLanding=false,
  selectionDisabled=false
}:{
  course:ReferencedCourse,
  isLoading:boolean,
  activities: ActivityNavigationItem[],
  description?: string;
  isStandaloneComponent?:boolean,
  initialActiveLoId?: number | null,
  deepLinkLanding?:boolean
  selectionDisabled?:boolean
}) => {

  return (
    <AccordionBody isStandaloneComponent={ isStandaloneComponent }>
      { !isStandaloneComponent && (
        <>
          { isLoading && <Skeleton variant="text" width={ 210 } /> }
          { description && (
            <DescriptionTypography>
              { description }
            </DescriptionTypography>
          ) }
        </>
      ) }
      { isLoading && <SkeletonCard /> }

      { !isLoading && activities?.length > 0 && (
        <ActivityDotNavigation
          activities={ activities }
          initialActiveLoId={ initialActiveLoId }
          courseId={ course.id }
          deepLinkLanding={ deepLinkLanding }
          selectionDisabled={ selectionDisabled }
        />
      ) }
    </AccordionBody>
  );
};

export default ActivityAccordion;
